//windowState

export function resizeWindow(width, height){
  return {
    type: 'RESIZE_WINDOW',
    windowWidth: width,
    windowHeight: height
  }
}

export function setLessonHeight(lessonHeight){
  return {
    type: 'SET_LESSON_HEIGHT',
    lessonHeight: lessonHeight
  }
}

export function setCourseScroll(scrollTop){
  return {
    type: 'SCROLL_COURSE_WINDOW',
    scrollTop: scrollTop
  }
}



// WEBPACK FOOTER //
// ./src/actions/windowState.js